export function generateHexSequence(length: number) {
    let hexSequence = '';
    const hexChars = '0123456789abcdef';
    
    for (let i = 0; i < length; i++) {
      hexSequence += hexChars[Math.floor(Math.random() * 16)];
    }
    
    return hexSequence;
  }